import { render, staticRenderFns } from "./NotificationTile.vue?vue&type=template&id=aa58c0c6&scoped=true&"
import script from "./NotificationTile.vue?vue&type=script&lang=js&"
export * from "./NotificationTile.vue?vue&type=script&lang=js&"
import style0 from "./NotificationTile.vue?vue&type=style&index=0&id=aa58c0c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa58c0c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VAvatar,VCard,VCol,VIcon})
